import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uv-tile-look" }
const _hoisted_2 = { class: "uv-tile-look-buttons" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Quick View", -1)
const _hoisted_5 = [
  _hoisted_4
]

import { computed } from 'vue'; 
	
	import { useStore } from 'vuex';
	// import { ECtas } from '@/enums';
	import { IVehicle } from '@/types.d'
	import { StarEmpty, StarFilled } from '@/svg';
import { ECtas } from '@/enums';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null
  },
  setup(__props: any) {

const props = __props as {
		vehicle: IVehicle
	}

	

	const store = useStore();
	const isSaved = computed(() => store.state.savedVehicles.includes(props.vehicle.StockIdentifier || props.vehicle.StockNum));

	const handleStarClick = (): void => {
		const myId = props.vehicle.StockIdentifier || props.vehicle.StockNum;
		const cookieSavedVehicles = JSON.parse(localStorage.getItem(`uvSaved-${props.vehicle.StockCategoryId}`) || '[]');

		isSaved.value ? 
			cookieSavedVehicles.splice(cookieSavedVehicles.indexOf(myId), 1) : 
			cookieSavedVehicles.push(myId);
		store.commit(isSaved.value ? 'removeSavedVehicle' : 'addSavedVehicle', myId);
		localStorage.setItem(`uvSaved-${props.vehicle.StockCategoryId}`, JSON.stringify(cookieSavedVehicles));
	}
	const handleViewClick = (e: Event): void => {
		e.preventDefault();
		store.commit('setEnquiryModal', {
			isVisible: true, 
			type: ECtas.quickLook, 
			vehicle: props.vehicle
		});
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "uv-tile-look-view",
        href: props.vehicle.DetailsPageUrl,
        onClick: handleViewClick
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        class: "uv-tile-look-save",
        onClick: handleStarClick
      }, [
        (_unref(isSaved))
          ? (_openBlock(), _createBlock(_unref(StarFilled), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(StarEmpty), { key: 1 }))
      ])
    ])
  ]))
}
}

})